import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getUser } from "../Store/Reducers/UserReducer";
import "./ProfileData.css";
import Step1 from "./Step1";
import StepHead from "./stepHead";
import "./stepper.css";
import StepperFoot from "./stepperFoot";
import { useRef } from 'react';
import { useDispatch } from "react-redux";
import { setLoader } from '../Store/Reducers/UserReducer';
import LoginFun from './../Layout Component/Loginfun';
import { getProfileData } from "../services/ProfileService";
import 'react-toastify/dist/ReactToastify.css';
import {  toast } from 'react-toastify';


export default function ProfileData(props) {
  const isloadinglayout = props.isLoading
  const url = process.env.REACT_APP_OXAR_API_URL;
  const uData = useSelector(getUser);
  const dispatch = useDispatch();
  const [ProfileData, setProfileData] = useState();
  const [file, setfile] = useState();
  const [index, setIndex] = useState(0);
  const [show, setshow] = useState(false);
  const [stat, setStat] = useState({
    name: "React",
    comp: () => <Step1 />,
  });
  const [steps, setSteps] = useState([
    import("./Step1"),
    import("./Step2"),
    import("./Step3"),
    import("./Step4"),
    import("./Step5"),
  ]);

  const [imgUrl, setImgUrl] = useState("");
  const inputRef = useRef(null);
  var data = LoginFun();

  let defaultImage = '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';

  //****************************Image Uploading**************************************************//
  const handleClick = () => {
    // ??? open file input box on click of other element
    inputRef.current.click();

  };

  const handleFileChange = event => {
    setfile(event);
    let reader = new FileReader();
    //setImgUrl(event);
    if (event) {
      reader.readAsDataURL(event[0]);
    }
    reader.onload = (_event) => {
      setImgUrl(reader.result);
      setshow(true);
    }
  }

  const Uploadfile = async () => {
    if (file !== undefined) {
      const validImageTypes = [
        'image/jpg',
        'image/png',
        'image/jpeg',
      ];
      if (!validImageTypes.includes(file[0].type)) {
        toast.error('This File Type Not Allowed to Upload in Profile Picture', {
          autoClose: 5000,
          hideProgressBar: true,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          theme: "colored"
        }
        )
        return
      }
      var filesize = Number(((file[0].size / 1024) / 1024).toFixed(4)); // MB
      if (filesize >= 3) {
        return toast.error('The Maximum Size Limit of Profile Picture is 3 MB', {
          autoClose: 5000,
          hideProgressBar: true,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          className: 'toast-message'
        }
        )
      }
      const formData = new FormData();
      let MainUserId = localStorage.getItem("UserID");
      formData.append('id', MainUserId);
      formData.append('file', file[0]);
      dispatch(setLoader(true));
      const tokenMain = sessionStorage.getItem("AuthToken")
      const res = await fetch(`${url}api/Profile/UpdateImage`, {
        method: "PUT",
        body: formData,
        headers: { "Authorization": 'Bearer ' + tokenMain },
      }).then((res) => res.json());
      if (res['content'] === true) {

        toast.success('Profile picture successfully uploaded', {
          autoClose: 5000,
          hideProgressBar: true,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          className: 'toast-message'
        }
        )
        setshow(false)
        profileDetail();
      }
      else {
        toast.error('Error while uploading profile', {
          autoClose: 5000,
          hideProgressBar: true,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          theme: "colored"
        }
        )
      }
      dispatch(setLoader(false));
    };
  }

  const profileDetail = async () => {
    debugger
    try {
      let MainUserId = localStorage.getItem("UserID");
      const res = await getProfileData(MainUserId)
      if (res.content)
      if(res.content.birthday != null){
        res.content.birthday = res.content['birthday'].substring(0, 10);
      }

      if(res.content.bcrm_datemovedtouk != null){
        res.content.bcrm_datemovedtouk = res.content['bcrm_datemovedtouk'].substring(0, 10);
      }
   
      setProfileData(res.content);
      localStorage.setItem("UserData",JSON.stringify(res.content))
      localStorage.setItem('PatientGender', res.content.gender);
    } 
    catch (e) {
    }
  }

  useEffect(() => {
    if (data === 1) {
      window.location.reload()
      data = 2;
    }
    profileDetail();
    if (uData.entityimage == null) {
      setImgUrl('data:image/png;base64,' + defaultImage);
    }
    else {
      setImgUrl('data:image/png;base64,' + uData.entityimage);
    }
    loadComponent(0);
  }, [uData]);

  const next = () => {
    debugger
    let ndx = index;
    if (ndx === 0 || ndx === 1) {
      if (ndx === 0 && ProfileData.title !== null && ProfileData.title !== "null" && ProfileData.firstName !== "" && ProfileData.lastName !== "" && ProfileData.gender !== null && ProfileData.gender !== "null" && ProfileData.email !== "" && ProfileData.relationShipStatus !== null && ProfileData.relationShipStatus !== "null") {
        if(ProfileData?.areYousureYouwanttosubmit != true){
          UpdatePatientData(ProfileData,ndx);
          // ndx++;
          // setIndex(ndx);
          // loadComponent(ndx);
        }
        else{
          ndx++;
          setIndex(ndx);
          loadComponent(ndx);
        }
        
      } else if (ndx === 1 && ProfileData.nhsNumber !== "" && ProfileData.idCardType !== "null" && ProfileData.idCardType !== null) {
        if(ProfileData?.areYousureYouwanttosubmit != true){
          UpdatePatientData(ProfileData,ndx);
          // ndx++;
          // setIndex(ndx);
          // loadComponent(ndx);
        }
        else{
          ndx++;
          setIndex(ndx);
          loadComponent(ndx);
        }
        
      }
      else {
        toast.warn('Please fill mandatory fields', {
          autoClose: 5000,
          hideProgressBar: true,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          className: 'toast-warn'
        }
        )
        return
      }
    } else {
      if(ProfileData?.areYousureYouwanttosubmit != true){
        UpdatePatientData(ProfileData,ndx);
      }
      else{
        ndx++;
        setIndex(ndx);
        loadComponent(ndx);
      }
    }
  };

  const loadComponent = (ndx) => {
    let component = steps[ndx];
    component.then((comp) => {
      setStat({ comp: comp.default });
    });
  };

  const UpdatePatientData = (DTO,ndx) => {
    debugger
    dispatch(setLoader(true));
    localStorage.setItem('PatientGender', DTO.gender);
    if(DTO.gender == 1) {
      DTO.gendercodeName ="Male"
    }
    if(DTO.gender == 2) {
      DTO.gendercodeName ="Female"
    }
    localStorage.setItem("UData",JSON.stringify(DTO));
    
    axios.put(`${url}/api/Profile/Update`, DTO).then((response) => {
      if (response.data.statusCode === 200) {
        //   Swal.fire({
        //     icon:'success',
        //     title: 'Patient updated successfully!'
        // })
        dispatch(setLoader(false));
        ndx++;
        setIndex(ndx);
        loadComponent(ndx);
      }
      dispatch(setLoader(false));
    }, (error) => {
      if(error.response.data.errorMessage == "Invalid json"){
        toast.error('Please dont use special characters in fields ', {
          autoClose: 5000,
          hideProgressBar: true,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          theme: "colored"
        }
        )
        dispatch(setLoader(false));
      return
      }
      else{
        toast.error('Error while updating', {
          autoClose: 5000,
          hideProgressBar: true,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          theme: "colored"
        }
        )
        dispatch(setLoader(false));
      return
      }
      dispatch(setLoader(false));
      return
    });
  }

  const previous = () => {
    let ndx = index;
    ndx--;
    setIndex(ndx);
    loadComponent(ndx);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Card className=" border-0 cardcolor">
          {/* <Card.Header className=" colorprofile   text-light">
            <h5>Profile</h5>
          </Card.Header> */}
          <Card.Body>
            <Card.Text>
              <div className="row  ">
                <div class="col-md-3 justify-content-center ">
                  <Card className="border-0 border-light shadow w-100  text-center">
                    <Card.Body>
                      <div className="testimonial-card mt-2 mb-3">
                        {/* Wrapper only — anchors the add-photo badge to the avatar. */}
                        <div className="pp-avatar-wrap">
                        {!(uData?.areYousureYouwanttosubmit) ?
                          <button onClick={handleClick} type="button" className="red-tooltip btn btn-primary  pull-right "
                            data-toggle="tooltip" data-placement="bottom"
                            title="Add profile picture" data-original-title="Tooltip on bottom"
                          >
                            <i className="fa fa-plus  " ></i></button> : null}
                        <div className="avatar mx-auto white" style={{ textAlign: 'center' }}>
                          <div className="image-upload">
                            <label for="file-input ">
                              <img className="img border  rounded-circle mb-3" src={imgUrl} style={{ width: "100%", height: "140px" }} />
                            </label>
                            <input style={{ display: 'none' }} ref={inputRef} type="file" onChange={e => handleFileChange(e.target.files)} />
                          </div>
                        </div>
                        </div>
                        {show &&
                          <div className=" uploadbtn">
                            <button type="button " className="btn colorprofile btn-block  text-white fs-5" id="Uploadprofilestyle"
                              onClick={Uploadfile}>Upload Profile Photo</button>
                          </div>
                        }
                      </div>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-md-9  ">
                  <Card className="border-0">
                    <Card.Body>
                      <div className="step-progress ">
                        <StepHead
                          stepCount={steps.length}
                          step={index}
                        />
                        <div className="stepsPlaceHolder ">
                          {ProfileData?.areYousureYouwanttosubmit === true ?
                            <>
                              <div className="text-danger pb-2">
                                <b className="container ">Please contact your clinic to have your profile unlocked</b>
                              </div>
                            </> : null
                          }
                          <stat.comp
                            next={next.bind(this)}
                            ProfileData={ProfileData}
                            setProfileData={setProfileData}
                            isloadinglayout={isloadinglayout}
                          />
                        </div>
                        <hr />
                        <StepperFoot
                          step={index}
                          stepCount={steps.length}
                          ProfileData={ProfileData}
                          next={next.bind(this)}
                          previous={previous.bind(this)}
                        />
                        <hr />
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      {/* <ToastContainer /> */}
    </>
  );
}
